/**
 * localStorage helper for delivery state persistence
 * Stores deferred stop IDs and custom stops, keyed to today's date.
 * Old date keys are automatically cleaned up on load.
 */

import { toLocalDateString } from './dateUtils'

const KEY_PREFIX = 'odin_delivery_state_'

function todayKey() {
  return KEY_PREFIX + toLocalDateString(new Date())
}

/**
 * Load delivery state for today, cleaning up stale date keys
 * @returns {{ deferredIds: string[], customStops: object[] }}
 */
export function loadDeliveryState() {
  const key = todayKey()

  // Clean up old date keys
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i)
    if (k && k.startsWith(KEY_PREFIX) && k !== key) {
      localStorage.removeItem(k)
    }
  }

  try {
    const raw = localStorage.getItem(key)
    if (!raw) return { deferredIds: [], customStops: [] }

    const parsed = JSON.parse(raw)
    return {
      deferredIds: Array.isArray(parsed.deferredIds) ? parsed.deferredIds : [],
      customStops: Array.isArray(parsed.customStops) ? parsed.customStops : []
    }
  } catch {
    return { deferredIds: [], customStops: [] }
  }
}

/**
 * Save delivery state for today
 * @param {{ deferredIds: string[], customStops: object[] }} state
 */
export function saveDeliveryState(state) {
  try {
    localStorage.setItem(todayKey(), JSON.stringify({
      deferredIds: state.deferredIds || [],
      customStops: state.customStops || []
    }))
  } catch (err) {
    console.warn('Failed to save delivery state:', err)
  }
}
